import { Link, useLocation } from 'react-router-dom';
import { Home, User, CreditCard, MessageCircle, LogOut, Menu, Settings, Zap, Book, Tool, Users, Briefcase, Share2, Shield, Key } from 'react-feather';
import { useContext, useState } from 'react';
import { UserContext } from '../UserContext';

// Same build-time flag Sidebar.js and Login.js read. Keep this menu's links in
// step with Sidebar.js, it is the only navigation below 768px, so a link
// missing here is unreachable on a phone.
const SSO_ENABLED = process.env.REACT_APP_SSO_ENABLED === 'true';

const MobileMenu = () => {
  const location = useLocation();
  const {
    logout,
    isPlatformAdmin,
    isOrganizationAdmin,
    isRestrictedOrganizationMember,
    organizationId,
    hasLeadFlow,
  } = useContext(UserContext);
  const [isOpen, setIsOpen] = useState(false);
  const showManagementLinks = !isRestrictedOrganizationMember;
  const showBusinessAssistants = organizationId !== null && organizationId !== undefined;
  const showAdminLink = isPlatformAdmin || isOrganizationAdmin;
  const adminLinkLabel = isPlatformAdmin ? 'Platform Admin' : 'Admin';

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="mobile-menu">
      <div className="mobile-menu-header">
        <img src="/images/NexOpta_Logo_Short.png" className="mobile-logo" alt="Nexopta" />
        <button
          type="button"
          className="mobile-menu-toggle"
          onClick={toggleMenu}
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isOpen}
        >
          <Menu />
        </button>
      </div>
      {isOpen && (
        <nav className="mobile-nav">
          <Link 
            className={`mobile-nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`} 
            to="/dashboard"
            onClick={() => setIsOpen(false)}
          >
            <Home /> Dashboard
          </Link>
          <Link 
            className={`mobile-nav-link ${location.pathname === '/account' ? 'active' : ''}`} 
            to="/account"
            onClick={() => setIsOpen(false)}
          >
            <User /> Account
          </Link>
          {showBusinessAssistants && (
            <Link 
              className={`mobile-nav-link ${location.pathname === '/businessassistants' ? 'active' : ''}`} 
              to="/businessassistants"
              onClick={() => setIsOpen(false)}
            >
              <Briefcase /> Business Assistants
            </Link>
          )}
          {showManagementLinks && (
            <>
              <Link 
                className={`mobile-nav-link ${location.pathname === '/billing' ? 'active' : ''}`} 
                to="/billing"
                onClick={() => setIsOpen(false)}
              >
                <CreditCard /> Billing
              </Link>
              <Link 
                className={`mobile-nav-link ${location.pathname === '/assistants' ? 'active' : ''}`} 
                to="/assistants"
                onClick={() => setIsOpen(false)}
              >
                <Users /> Agents
              </Link>
              <Link 
                className={`mobile-nav-link ${location.pathname === '/conversations' ? 'active' : ''}`} 
                to="/conversations"
                onClick={() => setIsOpen(false)}
              >
                <MessageCircle /> Logs
              </Link>
              <Link 
                className={`mobile-nav-link ${location.pathname === '/knowledge' ? 'active' : ''}`} 
                to="/knowledge"
                onClick={() => setIsOpen(false)}
              >
                <Book /> Knowledge
              </Link>
              <Link 
                className={`mobile-nav-link ${location.pathname === '/tools' ? 'active' : ''}`} 
                to="/tools"
                onClick={() => setIsOpen(false)}
              >
                <Tool /> Tools
              </Link>
              <Link
                className={`mobile-nav-link ${location.pathname === '/guardrails' ? 'active' : ''}`}
                to="/guardrails"
                onClick={() => setIsOpen(false)}
              >
                <Shield /> Guardrails
              </Link>
              <Link
                className={`mobile-nav-link ${location.pathname === '/workflow' ? 'active' : ''}`} 
                to="/workflow"
                onClick={() => setIsOpen(false)}
              >
                <Share2 /> AgentOps Studio
              </Link>
              {hasLeadFlow && (
                <Link 
                  className={`mobile-nav-link ${location.pathname === '/leadflow' ? 'active' : ''}`} 
                  to="/leadflow"
                  onClick={() => setIsOpen(false)}
                >
                  <Zap /> LeadFlow
                </Link>
              )}
            </>
          )}
          {showAdminLink && (
            <Link 
              className={`mobile-nav-link ${location.pathname === '/admin' ? 'active' : ''}`} 
              to="/admin"
              onClick={() => setIsOpen(false)}
            >
              <Settings /> {adminLinkLabel}
            </Link>
          )}
          {showAdminLink && SSO_ENABLED && (
            <Link
              className={`mobile-nav-link ${location.pathname === '/settings/sso' ? 'active' : ''}`}
              to="/settings/sso"
              onClick={() => setIsOpen(false)}
            >
              <Key /> Single sign-on
            </Link>
          )}
          <button
            className="mobile-nav-link logout-button" 
            onClick={() => {
              logout();
              setIsOpen(false);
            }}
          >
            <LogOut /> Log Out
          </button>
        </nav>
      )}
    </div>
  );
};

export default MobileMenu;
